import { EventEmitter } from 'events';


class ERUMAUI_Manager extends EventEmitter {
    Navigate = null;
    App_Properties = null;
    App_Navigation = null;
    Page_Properties = null;
    Page_Navigation = null;
    App_Path = null;
    App_CurrentPageName = null;
    Style_Properties = null;
    App_Subwindows = null;
    Subwindows_ActiveSubwindows = [];
    Subwindows_CurrentlyActiveSubwindow = null;
    States = {
        NavigationRail_Toggle: "Collapsed"
    }
    constructor() {
        super();
        // this.Initialize();
    }
    async Initialize() {
        this.Style_Properties = document.querySelector(":root");
        this.App_Path = window.location.pathname;
        this.App_CurrentPageName = this.App_Path.split("/").pop();
        // console.log(`Loading properties for page '${this.App_CurrentPageName}'`);
        await this.App_Properties_Load("Assets/Resource_Files/App_Properties.json");
        this.App_Navigation_Load("Assets/Resource_Files/App_Navigation.json");
        this.App_Subwindows_Load("Assets/Resource_Files/App_Subwindows.json");
        this.Page_Properties_Load();
        // Commands
        if (this.Element_Get_ByID("NavigationRail")) {
            this.Element_Attribute_Set(`NavigationRail`, "State", this.States.NavigationRail_Toggle);
        }

    }
    Initialize_Finalize() {
        // this.Navigation_Navigate("Navigation_Button_Home", "Slide_Home");
        this.LoadingScreen_Hide("Screen_Loading");
    }
    async App_Properties_Load(Path) {
        try {
            this.App_Properties = await this.Data_Import_FromPath(Path, "JSON");
            // console.log("Successfully loaded properties.");
            // console.log(this.App_Properties);
            this.emit("App_Properties_Loaded", this.App_Properties);
            this.Page_Properties_Load();
        } catch (Error) {
            console.error("Failed to load properties.", Error);
        }
    }
    async App_Navigation_Load(Path) {
        try {
            this.App_Navigation = await this.Data_Import_FromPath(Path, "JSON");
            // console.log("Successfully loaded navigation.");
            this.emit("App_Navigation_Loaded", this.App_Navigation);
            // this.Properties_Set();
            // await this.Page_Navigation_Load();
        } catch (Error) {
            console.error("Failed to load properties.", Error);
        }
    }
    async Page_Properties_Load() {
        try {
            for (let a = 0; a < this.App_Properties.App_Pages.length; a++) {
                if (this.App_Properties.App_Pages[a].Page_File == this.App_CurrentPageName) {
                    this.Page_Properties = this.App_Properties.App_Pages[a].Page_Properties;
                    // console.log("Succesfully loaded page properties.");
                    // console.log(this.Page_Properties);
                    break;
                }
            }
            if (this.Page_Properties == null) {
                this.Page_Properties = this.App_Properties.App_Pages[0].Page_Properties;
                // console.log("No page properties match current page. Resorting to the first item in the array.");
                // throw new Error("Properties not found");
            }
            // this.Properties_Set();
            this.emit("Page_Properties_Loaded", this.Page_Properties);
        } catch (Error) {
            console.error("Failed to load properties.", Error);
        }
    }
    async Page_Navigation_Load() {
        try {
            for (let a = 0; a < this.App_Navigation.App_Pages.length; a++) {
                if (this.App_Navigation.App_Pages[a].Page_File == this.App_CurrentPageName) {
                    this.Page_Navigation = this.App_Navigation.App_Pages[a];
                    // console.log("Succesfully loaded page navigation.");
                    // console.log(this.Page_Navigation);
                    break;
                }
            }
            if (this.Page_Navigation == null) {
                this.Page_Navigation = this.App_Navigation.App_Pages[0];
                // console.log("No navigation properties match current page. Resorting to the first item in the array.");
                // throw new Error("Properties not found");
            }
            this.emit("Page_Navigation_Loaded", this.Page_Navigation);
        } catch (Error) {
            console.error("Failed to load properties.", Error);
        }
    }
    async App_Subwindows_Load(Path) {
        try {
            // this.App_Subwindows = await this.Data_Import_FromPath(Path, "JSON");
            // console.log("Successfully loaded subwindow reference.");
            // this.emit("App_Subwindows_Loaded", this.App_Subwindows);
        } catch (Error) {
            console.error("Failed to load properties.", Error);
        }
    }
    Properties_Set_Old(Configuration) {

        try {
            this.Element_InnerText_Set("Window_Title", `${this.Page_Properties.Window.Title.Primary} ${this.Page_Properties.Window.Title.Separator} ${this.Page_Properties.Window.Title.Secondary}`);
            this.Element_Attribute_Set("Window_Icon", "href", this.Page_Properties.Window.Title.Icon);
            this.Element_InnerText_Set("Header_Navigator_Text", this.Page_Properties.Header.Navigation.Title);
            // Element_Attribute_Set("Header_Navigator_Icon", "src", Page_Properties.Header.Navigation.Icon);

            this.Style_Properties.style.setProperty("--Panel-Left-Width-Expanded", this.Page_Properties.Panels.Left.Width.Expanded);
            this.Style_Properties.style.setProperty("--Panel-Left-Width-Collapsed", this.Page_Properties.Panels.Left.Width.Collapsed);
            this.Style_Properties.style.setProperty("--Panel-Right-Width-Expanded", this.Page_Properties.Panels.Right.Width.Expanded);
            this.Style_Properties.style.setProperty("--Panel-Right-Width-Collapsed", this.Page_Properties.Panels.Right.Width.Collapsed);
            this.Style_Properties.style.setProperty("--Panel-Navigation-Rail-Width-Expanded", this.Page_Properties.NavigationRail.Width.Expanded);
            this.Style_Properties.style.setProperty("--Panel-Navigation-Rail-Width", this.Page_Properties.NavigationRail.Width.Collapsed);

            if (this.Page_Properties.Header.Enabled == true) {
                if (this.Element_isntNull("Header") == true) {
                    this.Element_Attribute_Set("Header", "State", "Enabled");
                    this.Element_InnerHTML_Set("Header_Navigation_Title", this.Page_Properties.Header.Navigation.Title);
                    this.Element_Attribute_Set("Header_Navigation_Icon", "src", this.Page_Properties.Header.Navigation.Icon);
                }
            } else {
                if (this.Element_isntNull("Header") == true) {
                    this.Element_Attribute_Set("Header", "State", "Disabled");
                }
            }

            if (this.Page_Properties.Panels.Left.Enabled == true) {
                this.Element_Attribute_Set("Panel_Left", "State", this.Page_Properties.Panels.Left.State);
                // Element_Attribute_Set("Panel_Toggle_Left", "State", Page_Properties.Panels.Left.State);
            } else {
                this.Element_Attribute_Set("Panel_Left", "State", "Disabled");
                // Element_Attribute_Set("Panel_Toggle_Left", "State", "Disabled");
            }
            if (this.Page_Properties.Panels.Right.Enabled == true) {
                this.Element_Attribute_Set("Panel_Right", "State", this.Page_Properties.Panels.Right.State);
                // Element_Attribute_Set("Panel_Toggle_Right", "State", Page_Properties.Panels.Right.State);
            } else {
                this.Element_Attribute_Set("Panel_Right", "State", "Disabled");
                // Element_Attribute_Set("Panel_Toggle_Right", "State", "Disabled");
            }
            if (this.Page_Properties.Panels.Center.Margins == true) {
                this.Element_Attribute_Set("Panel_Center", "Margins", "Active");
            } else {
                this.Element_Attribute_Set("Panel_Center", "Margins", "Inactive");
            }
        } catch (Error) {
            // console.log(Error);
        }
    }
    Element_Attribute_Get(ID, Attribute) {
        const Element = document.getElementById(ID);
        const Result = Element.getAttribute(Attribute);
        return Result;
    }
    Element_Attribute_Set(ID, Attribute, Value) {
        const Element = document.getElementById(ID);
        Element.setAttribute(Attribute, Value);
    }
    Element_Attribute_Remove(ID, Attribute) {
        const Element = document.getElementById(ID);
        Element.removeAttribute(Attribute);
    }
    Element_InnerHTML_Set(ID, Value) {
        const Element = document.getElementById(ID);
        Element.innerHTML = Value;
    }
    Element_InnerText_Set(ID, Value) {
        const Element = document.getElementById(ID);
        Element.innerText = Value;
    }
    Element_Value_Get(ID) {
        const Element = document.getElementById(ID);
        const Result = Element.value;
        return Result;
    }
    Element_Value_Set(ID, Value) {
        const Element = document.getElementById(ID);
        Element.value = Value;
    }
    Element_Get_ByID(ID) {
        return document.getElementById(ID);
    }
    Element_Get_ByQuery(Query) {
        return document.querySelector(Query);
    }
    Element_Get_ByQuery_All(Query) {
        return document.querySelectorAll(Query);
    }
    Element_Get_ByTag(ID, Tag) {
        return document.getElementById(ID).getElementsByTagName(Tag);
    }
    Element_Clear(ID) {
        this.Element_InnerHTML_Set(ID, "");
    }
    Element_Clear_ExceptFirst(ID) {
        for (let a = 1; a <= document.getElementById(ID).childNodes.length; a++) {
            document.getElementById(ID).removeChild(document.getElementById(ID).lastChild)
        }
    }
    Element_isntNull(ID) {
        if (document.getElementById(ID) == null) {
            return false;
        } else {
            return true;
        }
    }

    Element_isNull(ID) {
        if (document.getElementById(ID) == null) {
            return true;
        } else {
            return false;
        }
    }
    Element_Focus(ID) {
        document.getElementById(ID).focus();
    }
    Element_Style_Animate_Batch_QuerySelector(QuerySelector, Animation_Name, Animation_Duration, Animation_FillMode, Animation_Iteration, Animation_Delay) {
        var Element_Delay = 0;
        var Element_QuerySelector = this.Element_Get_ByQuery_All(QuerySelector);
        for (let a = 0; a < Element_QuerySelector.length; a++) {
            Element_QuerySelector[a].style.animationName = Animation_Name;
            Element_QuerySelector[a].style.Animation_Duration = Animation_Duration;
            Element_QuerySelector[a].style.animationFillMode = Animation_FillMode;
            Element_QuerySelector[a].style.animationIterationCount = Animation_Iteration;
            Element_Delay += Animation_Delay;
            if (Animation_Delay != 0) {
                Element_QuerySelector[a].style.animationDelay = Element_Delay + "ms";
            } else {
                Element_QuerySelector[a].style.animationDelay = "0s";
            }
        }
    }
    Element_Style_Display(ID, Display) {
        document.getElementById(ID).style.display = Display;
    }
    Element_Clickability_Toggle(ID) {
        var State = this.Element_Attribute_Get(ID, "Clickability");
        if (State == "Active") {
            this.Element_Attribute_Set(ID, "Clickability", "Unclickable")
            State = "Inactive";
        } else if (State == "Inactive" || State == null) {
            this.Element_Attribute_Set(ID, "Clickability", "Clickable");
            State = "Active"
        }
        this.emit("Element_Clickability_Toggled", { ID, State });
    }
    Data_Import_FromPath = async function (Path, Type) {
        var Data_Raw;
        var Data_JSON;
        try {
            await new Promise(resolve => {
                const request = new XMLHttpRequest();
                request.open("GET", Path, false);
                request.send();
                Data_Raw = request.responseText;
                Data_JSON = JSON.parse(Data_Raw);
                resolve();
            })
            if (Type == "JSON" || Type == null) {
                return Data_JSON;
            } else if (Type == "Raw") {
                return Data_Raw;
            }
        } catch (Error) {
            console.error(Error.message);
        }
    }

    Data_Import(FileInputElementID, Type) {
        var File_Element = document.getElementById(FileInputElementID);
        var File_Element_File = File_Element.files[0];
        const Reader = new FileReader();
        Reader.onload = function (e) {
            const Data_Raw = e.target.result;
            const Data_JSON = JSON.parse(Data_Raw);
            if (Type == "JSON" || Type == null) {
                return Data_JSON;
            } else if (Type == "Raw") {
                return Data_Raw;
            }
        }

        Reader.readAsText(File_Element_File);
    }

    LoadingScreen_Show(ID) {
        try {
            // var State = this.Element_Attribute_Get(ID, "State");
            // this.Element_Attribute_Set(ID, "State", "Active");
            // State = "Active";
            // this.emit("LoadingScreen_Toggled", { ID, State });
        } catch (Error) {
            console.error(Error);
        }
        
    }
    LoadingScreen_Hide(ID) {
        try {
            // var State = this.Element_Attribute_Get(ID, "State");
            // this.Element_Attribute_Set(ID, "State", "Inactive");
            // State = "Inactive";
            // this.emit("LoadingScreen_Toggled", { ID, State });
        } catch (Error) {
            console.error(Error);
        }
        
    }

    Slide_Properties_Set(Path) {
        try {
            // console.warn(`Attempting to set properties for slide ${Path}`)
            // console.warn(this.App_Navigation[Path]);
            if (this.App_Navigation[Path] != null) {
                var Page = this.App_Navigation[Path];
                var Page_Panel_Left = Page.Panels.Left;
                var Page_Panel_Center = Page.Panels.Center;
                var Page_Panel_Right = Page.Panels.Right;
                var Page_Ribbons = Page.Ribbon;
                var Page_Properties = Page.Properties;

                this.Page_Properties.Panels.Left.Enabled = false;
                this.Page_Properties.Panels.Right.Enabled = false;
                if (Page_Panel_Left.Enabled) {
                    this.Page_Properties.Panels.Left.Enabled = true;
                    if (Page_Panel_Left.State == "Expanded") {
                        this.Page_Properties.Panels.Left.State = "Expanded";
                        this.Element_Attribute_Set("Panel_Left_Control", "State", "Expanded");
                    } else if (Page_Panel_Left.State == "Collapsed") {
                        this.Page_Properties.Panels.Left.State = "Collapsed";
                        this.Element_Attribute_Set("Panel_Left_Control", "State", "Collapsed");
                    }
                    this.Page_Properties.Panels.Left.Width.Expanded = Page_Panel_Left.Width.Expanded;
                    this.Page_Properties.Panels.Left.Width.Collapsed = Page_Panel_Left.Width.Collapsed;
                    this.Element_InnerText_Set("Panel_Left_Control_Title", Page_Panel_Left.Title);
                } else {
                    this.Element_Attribute_Set("Panel_Left", "State", "Disabled");
                    this.Element_Attribute_Set("Panel_Left_Control", "State", "Disabled");
                    this.Element_InnerText_Set("Panel_Left_Control_Title", "");
                    // this.Element_Attribute_Set("Panel_Left", "State", "Disabled");
                }
                if (Page_Panel_Right.Enabled) {
                    this.Page_Properties.Panels.Right.Enabled = true;
                    if (Page_Panel_Right.State == "Expanded") {
                        this.Page_Properties.Panels.Right.State = "Expanded";
                        this.Element_Attribute_Set("Panel_Right_Control", "State", "Expanded");
                    } else if (Page_Panel_Right.State == "Collapsed") {
                        this.Page_Properties.Panels.Right.State = "Collapsed";
                        this.Element_Attribute_Set("Panel_Right_Control", "State", "Collapsed");
                    }
                    this.Page_Properties.Panels.Right.Width.Expanded = Page_Panel_Right.Width.Expanded;
                    this.Page_Properties.Panels.Right.Width.Collapsed = Page_Panel_Right.Width.Collapsed;
                    this.Element_InnerText_Set("Panel_Right_Control_Title", Page_Panel_Right.Title);
                } else {
                    this.Element_Attribute_Set("Panel_Right", "State", "Disabled");
                    this.Element_Attribute_Set("Panel_Right_Control", "State", "Disabled");
                    this.Element_InnerText_Set("Panel_Right_Control_Title", "");
                }
                if (!Page_Panel_Left.Toggle) {
                    this.Element_Attribute_Set("Panel_Left_Control", "State", "Disabled");
                    this.Element_Attribute_Set("Panel_Left", "State_Controls", "Inactive");
                } else {
                    this.Element_Attribute_Set("Panel_Left", "State_Controls", "Active");
                }
                if (!Page_Panel_Right.Toggle) {
                    this.Element_Attribute_Set("Panel_Right_Control", "State", "Disabled");
                    this.Element_Attribute_Set("Panel_Right", "State_Controls", "Inactive");
                } else {
                    this.Element_Attribute_Set("Panel_Right", "State_Controls", "Active");
                }
                if (Page_Panel_Center.Margins) {
                    this.Page_Properties.Panels.Center.Margins = true;
                } else {
                    this.Page_Properties.Panels.Center.Margins = false;
                }
                if (Page_Ribbons.Enabled) {
                    this.Element_Attribute_Set("Ribbon", "State", "Active");
                    this.Element_Attribute_Set("Panels", "State_Ribbon", "Active");
                    this.Element_Attribute_Set("Panels_Controls", "State_Ribbon", "Active");
                } else {
                    this.Element_Attribute_Set("Ribbon", "State", "Inactive");
                    this.Element_Attribute_Set("Panels", "State_Ribbon", "Inactive");
                    this.Element_Attribute_Set("Panels_Controls", "State_Ribbon", "Inactive");
                }
                // this.Properties_Set("Update");
                // console.warn("Done");
                this.Element_InnerText_Set("Header_Title", Page_Properties.Header_Title);
            }
        } catch (Error) {
            console.error(Error);
        }
    }

    Navigation_Navigate_Old(ButtonID, SlideID) {
        try {
            // console.log(`Attempting to navigate to ${ButtonID} | ${SlideID}`);
            var Target_Slide = SlideID;
            var Slide = this.Page_Navigation.Slides.find(slide => slide.ID === Target_Slide);

            var ID_Panel_Left = Slide.Panels.Left.Linked_ID;
            var ID_Panel_Center = Slide.Panels.Center.Linked_ID;
            var ID_Panel_Right = Slide.Panels.Right.Linked_ID;
            var Title_Header = Slide.Name;
            var Enable_Panel_Left = Slide.Panels.Left.Enabled;
            var Enable_Panel_Right = Slide.Panels.Right.Enabled;
            var Enable_Ribbon = Slide.Ribbon.Enabled;
            var State_Panel_Left = Slide.Panels.Left.State;
            var State_Panel_Right = Slide.Panels.Right.State;
            var Width_Expanded_Panel_Left = Slide.Panels.Left.Width.Expanded;
            var Width_Collapsed_Panel_Left = Slide.Panels.Left.Width.Collapsed;
            var Width_Expanded_Panel_Right = Slide.Panels.Right.Width.Expanded;
            var Width_Collapsed_Panel_Right = Slide.Panels.Right.Width.Collapsed;
            var ID_Ribbon = Slide.Ribbon.Linked_ID;
            var Panel_Center_Margins = Slide.Panels.Center.Margins;

            for (let a = 0; a <= this.Element_Get_ByQuery_All(".NavigationRail_Item").length - 1; a++) {
                this.Element_Get_ByQuery_All(".NavigationRail_Item")[a].setAttribute("State", "Inactive");
            }
            for (let a = 0; a <= this.Element_Get_ByTag("root", "ui-panel-slide").length - 1; a++) {
                this.Element_Get_ByTag("root", "ui-panel-slide")[a].setAttribute("State", "Inactive");
            }
            for (let a = 0; a <= this.Element_Get_ByTag("root", "ui-ribbon-group").length - 1; a++) {
                this.Element_Get_ByTag("root", "ui-ribbon-group")[a].setAttribute("State", "Inactive");
            }

            this.Element_Attribute_Set(ButtonID, "State", "Active");
            this.Element_Attribute_Set(ID_Panel_Left, "State", "Active");
            this.Element_Attribute_Set(ID_Panel_Center, "State", "Active");
            this.Element_Attribute_Set(ID_Panel_Right, "State", "Active");

            this.Element_InnerHTML_Set("Header_Title", Title_Header);
            if (Enable_Ribbon == true) {
                this.Element_Attribute_Set(ID_Ribbon, "State", "Active");
            }
            if (Enable_Panel_Left == true) {
                this.Page_Properties.Panels.Left.Enabled = true;
                this.Page_Properties.Panels.Left.State = State_Panel_Left;
                this.Page_Properties.Panels.Left.Width.Expanded = Width_Expanded_Panel_Left;
                this.Page_Properties.Panels.Left.Width.Collapsed = Width_Collapsed_Panel_Left;
            } else {
                this.Page_Properties.Panels.Left.Enabled = false;
            }
            if (Enable_Panel_Right == true) {
                this.Page_Properties.Panels.Right.Enabled = true;
                this.Page_Properties.Panels.Right.State = State_Panel_Right;
                this.Page_Properties.Panels.Right.Width.Expanded = Width_Expanded_Panel_Right;
                this.Page_Properties.Panels.Right.Width.Collapsed = Width_Collapsed_Panel_Right;
            } else {
                this.Page_Properties.Panels.Right.Enabled = false;
            }
            if (Panel_Center_Margins == true) {
                this.Page_Properties.Panels.Center.Margins = true;
            } else {
                this.Page_Properties.Panels.Center.Margins = false;
            }
            // this.Properties_Set("Update");
        } catch (Error) {
            console.error("An error occured", Error);
        }

    }

    Navigation_Toggle() {
        if (this.Page_Properties?.NavigationRail?.Enabled == true) {
            if (this.States.NavigationRail_Toggle == "Collapsed") {
                this.States.NavigationRail_Toggle = "Expanded";
                // this.Element_Attribute_Set(`NavigationRail`, "State", this.States.NavigationRail_Toggle);
                if (this.Page_Properties.NavigationRail.PushPanels == true) {
                    this.Style_Properties.style.setProperty("--Panels-Margin-Left", this.Page_Properties.NavigationRail.Width.Expanded);
                }
                // Element_Attribute_Set(`Panels`, "State_Navigation", "Expanded");
                // Element_Attribute_Set(`Panel_Toggle_Left`, "State_Navigation", "Expanded");
            } else {
                this.States.NavigationRail_Toggle = "Collapsed";
                // this.Element_Attribute_Set(`NavigationRail`, "State", this.States.NavigationRail_Toggle);
                if (this.Page_Properties.NavigationRail.PushPanels == true) {
                    this.Style_Properties.style.setProperty("--Panels-Margin-Left", this.Page_Properties.NavigationRail.Width.Collapsed);
                }
                // Element_Attribute_Set(`Panels`, "State_Navigation", "Collapsed");Element_Attribute_Set(`Panel_Toggle_Left`, "State_Navigation", "Collapsed");
            }
        }
    }

    Subwindows_Open_Old(ID) {
        // console.log(ID);
        if (this.Subwindows_ActiveSubwindows.length <= 0) {
            this.Element_Attribute_Set("Subwindows", "State", "Active");
        }
        this.Subwindows_ActiveSubwindows.push(ID);

        for (let a = 0; a < this.Subwindows_ActiveSubwindows.length - 1; a++) {
            this.Element_Attribute_Set(this.Subwindows_ActiveSubwindows[a], "State", "Inactive");
        }

        this.Subwindows_CurrentlyActiveSubwindow = this.Subwindows_ActiveSubwindows[this.Subwindows_ActiveSubwindows.length - 1];
        // console.log(this.Subwindows_CurrentlyActiveSubwindow);

        this.emit("Subwindow_Opened", {
            Subwindows_Active: [...this.Subwindows_ActiveSubwindows],
            Subwindows_Current: this.Subwindows_CurrentlyActiveSubwindow
        });
        setTimeout(function () {
            this.Element_Attribute_Set(ID, "Visibility", "Open");
            this.Element_Attribute_Set(ID, "State", "Active");
            // document.getElementById(ID).style.zIndex = this.Subwindows_ActiveSubwindows.length;
        }, 500);
    }

    Subwindows_Close_Old(ID) {
        this.Subwindows_ActiveSubwindows.splice(this.Subwindows_ActiveSubwindows.indexOf(ID), 1);
        this.Element_Attribute_Set(ID, "Visibility", "Closed");
        this.Element_Attribute_Set(ID, "State", "Inactive");
        // setTimeout(function () {
        //     this.Element_Attribute_Remove(ID, "Visibility");
        //     this.Element_Attribute_Remove(ID, "State");
        // }, 300);
        if (this.Subwindows_ActiveSubwindows.length > 0) {
            for (let a = 0; a < this.Subwindows_ActiveSubwindows.length - 1; a++) {
                this.Element_Attribute_Set(this.Subwindows_ActiveSubwindows[a], "State", "Inactive");
            }
            this.Element_Attribute_Set(this.Subwindows_ActiveSubwindows[this.Subwindows_ActiveSubwindows.length - 1], "State", "Active");
        } else if (this.Subwindows_ActiveSubwindows.length <= 0) {
            this.Element_Attribute_Set("Subwindows", "State", "Inactive");
            setTimeout(function () {
                this.Element_Attribute_Remove("Subwindows", "State");
            }, 300);
        }
        setTimeout(() => {
            this.Subwindows_CurrentlyActiveSubwindow = this.Subwindows_ActiveSubwindows[this.Subwindows_ActiveSubwindows.length - 1];
            this.emit("Subwindow_Closed", {
                Subwindows_Active: [...this.Subwindows_ActiveSubwindows],
                Subwindows_Current: this.Subwindows_CurrentlyActiveSubwindow
            })
        }, 300);
    }



    Subwindows_Open(ID, ReturnPath) {
        // console.log(ID);
        this.emit("Subwindow_Request_Open", {
            ID: ID,
            ReturnPath: ReturnPath
        });
    }

    Subwindows_Close(ID) {
        // console.log(ID);
        this.emit("Subwindow_Request_Close", {
            ID: ID
        });
    }
    Dropdown_ToggleList(ID) {
        var Dropdown_State = this.Element_Attribute_Get(ID, "State");
        var Dropdown_List_Items = document.getElementById(ID).querySelectorAll(".Dropdown_List_Item");
        if (Dropdown_State == "Inactive" || Dropdown_State == null) {
            document.getElementById(ID).querySelector(".Dropdown_Button").focus();
            this.Element_Attribute_Set(ID, "State", "Active");
            for (let a = 0; a < Dropdown_List_Items.length; a++) {
                Dropdown_List_Items[a].removeAttribute("disabled");
            }
        } else if (Dropdown_State == "Active") {
            document.getElementById(ID).querySelector(".Dropdown_Button").focus();
            this.Element_Attribute_Set(ID, "State", "Inactive");
            for (let a = 0; a < Dropdown_List_Items.length; a++) {
                Dropdown_List_Items[a].setAttribute("disabled", "");
            }
        }
        this.emit("Dropdown_Toggled", {
            List_ID: ID,
            List_State: Dropdown_State
        });
    }
    Dropdown_SubmitValue(ParentNodeID, InnerText, Index) {
        document.getElementById(ParentNodeID).querySelector(".Dropdown_Button_Text").innerText = InnerText;
        document.getElementById(ParentNodeID).querySelector(".Dropdown_Button").click();
        this.emit("Dropdown_Value_Submitted", {
            List_ID: ParentNodeID,
            Value: InnerText,
            Value_Index: Index
        });
    }
    Buttons_Toggle(ID) {
        var Button_Element = document.getElementById(ID);
        if (Button_Element.getAttribute("State") == "Active") {
            Button_Element.setAttribute("State", "Inactive");
            Button_Element.setAttribute("IsActive", "false");
        } else if (Button_Element.getAttribute("State") == "Inactive") {
            Button_Element.setAttribute("State", "Active");
            Button_Element.setAttribute("IsActive", "true");
        } else if (Button_Element.getAttribute("State") == null) {
            Button_Element.setAttribute("State", "Active");
            Button_Element.setAttribute("IsActive", "true");
        }
        this.emit("Button_Toggled", {
            ID: ID,
            State: Button_Element.getAttribute("State")
        });
    }
    Radio_Select(ID, Parent_ID) {
        var Radio_Button_Element = document.getElementById(ID);
        var Radio_Button_Parent_Element;
        if (Parent_ID == null) {
            Radio_Button_Parent_Element = document.getElementById(ID).parentNode;
        } else {
            Radio_Button_Parent_Element = document.getElementById(Parent_ID);
        }
        var Radio_Button_Parent_Children_Elements = document.querySelectorAll(".Radio_Button");
        for (let a = 0; a < Radio_Button_Parent_Children_Elements.length; a++) {
            Radio_Button_Parent_Children_Elements[a].setAttribute("State", "Inactive");
        }
        Radio_Button_Parent_Element.setAttribute("Radio_ActiveButton", ID);
        Radio_Button_Element.setAttribute("State", "Active");
        this.emit("Radio_Selected", {
            ID_Parent: Radio_Button_Parent_Element.getAttribute("id"),
            ID_ActiveButton: ID,
            ID_ActiveButton_Index: Radio_Button_Element.getAttribute("Index")
        });
    }
    TextArea_SnapToSize(ID) {
        var TextAreas = document.getElementById(ID);
        if (TextAreas.getAttribute("Autoresize") == "true") {
            TextAreas.style.height = 'auto';
            TextAreas.style.height = ((TextAreas.scrollHeight) - 20) + 'px';
        }
    }
    Page_Navigator_Set(Function) {
        this.Navigate = Function;

    }
    Page_ChangePage(Page, Mode) {
        try {
            if (Mode == null || Mode == "Loading") {
                this.LoadingScreen_Show("Screen_Loading");
                setTimeout(() => {
                    this.Navigate(Page);
                    setTimeout(() => {
                        this.LoadingScreen_Hide('Screen_Loading')
                    }, 500);
                }, 500);

            } else {
                this.Navigate(Page);
            }
            this.emit("Page_Changed", {
                Page: Page,
                Mode: Mode
            });
        } catch (Error) {
            console.error("An error occured", Error);
        }
    }

    async Input_Evaluate(Inputs) {
        try {
            if (Inputs.length > 0) {
                var Evaluation_Score = 0;
                var Evaluation_Score_Max = Inputs.length;
                for (let a = 0; a < Inputs.length; a++) {
                    var Item = Inputs[a];
                    if (Item.Type != "Time_Range" &&
                        Item.Type !== "Time_Range_Custom" &&
                        Item.Type != "Time_Range_Month" &&
                        Item.Type != "Time_Range_Month_Custom" &&
                        Item.Type !== "Time_Range_Week" &&
                        Item.Type !== "Time_Range_Week_Custom" &&
                        Item.Type !== "Time_Range_Date" &&
                        Item.Type !== "Time_Range_Date_Custom" &&
                        Item.Type !== "Compare_Sameness" &&
                        Item.Type !== "Compare_Difference") {
                        this.Element_Attribute_Set(Item.ID, "Validation", null);
                    } else {
                        this.Element_Attribute_Set(Item.ID_Start, "Validation", null);
                        this.Element_Attribute_Set(Item.ID_End, "Validation", null);
                    }
                    if (Item.Prompt) {
                        if (
                            Item.Type === "Time_Range" ||
                            Item.Type === "Time_Range_Custom" ||
                            Item.Type === "Time_Range_Month" ||
                            Item.Type === "Time_Range_Month_Custom" ||
                            Item.Type === "Time_Range_Week" ||
                            Item.Type === "Time_Range_Week_Custom" ||
                            Item.Type === "Time_Range_Date" ||
                            Item.Type === "Time_Range_Date_Custom" ||
                            Item.Type === "Compare_Sameness" ||
                            Item.Type === "Compare_Difference") {
                            if (document.getElementById(`${Item.ID_Start}_Prompt`)) {
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Inactive");
                            }
                            if (document.getElementById(`${Item.ID_End}_Prompt`)) {
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Inactive");
                            }
                        } else {
                            if (document.getElementById(`${Item.ID}_Prompt`)) {
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Inactive");
                            }
                        }
                    }

                    if (Item.Type == "Text") {
                        // console.log("Evaluating");
                        if (this.Element_Value_Get(Item.ID) !== Item.AC &&
                            this.Element_Value_Get(Item.ID)) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Active");
                            }

                        }
                    }
                    if (Item.Type == "Dropdown") {
                        if (document.getElementById(Item.ID).querySelector(".Dropdown_Button_Text").innerText !== Item.AC &&
                            document.getElementById(Item.ID).querySelector(".Dropdown_Button_Text").innerText
                        ) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type == "Time_Range") {
                        const todayISO = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
                        const start = new Date(`${todayISO}T${this.Element_Value_Get(Item.ID_Start)}`);
                        const end = new Date(`${todayISO}T${this.Element_Value_Get(Item.ID_End)}`);

                        if (end > start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type == "Time_Range_Custom") {
                        const todayISO = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
                        const start = new Date(`${todayISO}T${this.Element_Value_Get(`${Item.ID_Start}_Input_Raw`)}`);
                        const end = new Date(`${todayISO}T${this.Element_Value_Get(`${Item.ID_End}_Input_Raw`)}`);
                        if (end > start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type === "Time_Range_Month") {
                        const Start = this.Element_Value_Get(Item.ID_Start).split("-");
                        const End = this.Element_Value_Get(Item.ID_End).split("-");
                        // Year check
                        if (End[0] >= Start[0]) {
                            // Month check
                            if (End[1] >= Start[1]) {
                                Evaluation_Score++;
                            } else {
                                this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                                this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                                if (Item.Prompt) {
                                    this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                    this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                    this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                    this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                                }
                            }
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type === "Time_Range_Month_Custom") {
                        const Start = this.Element_Value_Get(`${Item.ID_Start}_Input_Raw`).split("-");
                        const End = this.Element_Value_Get(`${Item.ID_End}_Input_Raw`).split("-");
                        // Year check
                        if (End[0] >= Start[0]) {
                            // Month check
                            if (End[1] >= Start[1]) {
                                Evaluation_Score++;
                            } else {
                                this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                                this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                                if (Item.Prompt) {
                                    this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                    this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                    this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                    this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                                }
                            }
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type === "Time_Range_Week") {
                        const Start = this.Element_Value_Get(Item.ID_Start);
                        const End = this.Element_Value_Get(Item.ID_End);

                        if (End >= Start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type === "Time_Range_Week_Custom") {
                        const Start = this.Element_Value_Get(`${Item.ID_Start}_Input_Raw`);
                        const End = this.Element_Value_Get(`${Item.ID_End}_Input_Raw`);

                        if (End >= Start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type == "Time_Range_Date_Custom") {
                        const todayISO = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
                        const start = this.Element_Value_Get(`${Item.ID_Start}_Input_Raw`);
                        const end = this.Element_Value_Get(`${Item.ID_End}_Input_Raw`);
                        if (end > start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type == "Date") {
                        const selected = new Date(this.Element_Value_Get(Item.ID));
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // reset to start of today

                        let valid = true;
                        if (Item.AC === "Past") {
                            if (selected < today) valid = false;
                        }

                        if (valid) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    if (Item.Type === "Compare_Sameness") {
                        const Start = this.Element_Value_Get(Item.ID_Start);
                        const End = this.Element_Value_Get(Item.ID_End);

                        if (End === Start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }

                    if (Item.Type === "Compare_Difference") {
                        const Start = this.Element_Value_Get(Item.ID_Start);
                        const End = this.Element_Value_Get(Item.ID_End);

                        if (End !== Start) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID_Start, "Validation", "Error");
                            this.Element_Attribute_Set(Item.ID_End, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID_Start}_Prompt`, Item.Prompt);
                                this.Element_InnerHTML_Set(`${Item.ID_End}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID_Start}_Prompt`, "State", "Active");
                                this.Element_Attribute_Set(`${Item.ID_End}_Prompt`, "State", "Active");
                            }
                        }
                    }

                    if (Item.Type === "Password_New") {
                        const Password = this.Element_Value_Get(Item.ID).trim();
                        var Evaluation_Score_Local = 0;
                        var Prompt_Message = [];
                        const Rules = {
                            Length: Password.length >= 8,
                            Upper: /[A-Z]/.test(Password),
                            Lower: /[a-z]/.test(Password),
                            Number: /[0-9]/.test(Password),
                            Special: /[!@#$%^&*_]/.test(Password)
                        }
                        if (Rules.Length) {
                            Evaluation_Score_Local++;
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Length`, "State", "Passed");
                            }
                        } else {
                            Prompt_Message.push("<li>have at least 8 characters</li>");
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Length`, "State", "Fail");
                            }
                        }
                        if (Rules.Upper) {
                            Evaluation_Score_Local++;
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Upper`, "State", "Passed");
                            }
                        } else {
                            Prompt_Message.push("<li>have at least 1 uppercase character</li>");
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Upper`, "State", "Fail");
                            }
                        }
                        if (Rules.Lower) {
                            Evaluation_Score_Local++;
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Lower`, "State", "Passed");
                            }
                        } else {
                            Prompt_Message.push("<li>have at least 1 lowercase character</li>");
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Lower`, "State", "Fail");
                            }
                        }
                        if (Rules.Number) {
                            Evaluation_Score_Local++;
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Number`, "State", "Passed");
                            }
                        } else {
                            Prompt_Message.push("<li>have at least 1 number</li>");
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Number`, "State", "Fail");
                            }
                        }
                        if (Rules.Special) {
                            Evaluation_Score_Local++;
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Special`, "State", "Passed");
                            }
                        } else {
                            Prompt_Message.push("<li>have at least 1 special character (!@#$%^&*)</li>");
                            if (Item.Indicator) {
                                this.Element_Attribute_Set(`${Item.Indicator}_Special`, "State", "Fail");
                            }
                        }
                        if (Evaluation_Score_Local == 5) {
                            Evaluation_Score++;
                            // if (Item.Indicator) {
                            //     this.Element_InnerHTML_Set(`${Item.Indicator}`, ``);
                            //     this.Element_Attribute_Set(`${Item.Indicator}`, "State", "Active");
                            // }
                        } else {
                            console.error(Evaluation_Score_Local);
                            console.error(Prompt_Message);
                            this.Element_Attribute_Set(Item.ID, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID}_Prompt`, `Password must ${Prompt_Message.join("")}`);
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Active");
                            }
                            // if (Item.Indicator) {

                                
                            //     this.Element_InnerHTML_Set(`${Item.Indicator}`, `<ul>Password must ${Prompt_Message.join("")}</ul>`);
                            //     this.Element_Attribute_Set(`${Item.Indicator}`, "State", "Active");
                            // }
                        }
                    }
                    if (Item.Type === "Email") {
                        const Email = this.Element_Value_Get(Item.ID);
                        const Email_Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (Email_Regex.test(Email)) {
                            Evaluation_Score++;
                        } else {
                            this.Element_Attribute_Set(Item.ID, "Validation", "Error");
                            if (Item.Prompt) {
                                this.Element_InnerHTML_Set(`${Item.ID}_Prompt`, Item.Prompt);
                                this.Element_Attribute_Set(`${Item.ID}_Prompt`, "State", "Active");
                            }
                        }
                    }
                    // console.log(Evaluation_Score);
                }
                if (Evaluation_Score == Evaluation_Score_Max) {
                    // console.log("Evaluation finished - success");
                    this.emit("Evaluation_Finished", {
                        Evaluated: Inputs,
                        Evaluation_Score: Evaluation_Score,
                        Evaluation_Score_Max: Evaluation_Score_Max,
                        Verdict: true
                    });
                    // console.log(Evaluation_Score);
                    // console.log(Evaluation_Score_Max);
                    return true;
                } else {
                    // console.log("Evaluation finished - failed");
                    this.emit("Evaluation_Finished", {
                        Evaluated: Inputs,
                        Evaluation_Score: Evaluation_Score,
                        Evaluation_Score_Max: Evaluation_Score_Max,
                        Verdict: false
                    });
                    // console.log(Evaluation_Score);
                    // console.log(Evaluation_Score_Max);
                    return false;
                }
            }
        } catch (Error) {
            console.error("An error occured", Error);
        }

    }

    Refresh() {
        this.emit("UI_Refresh");
    }

    Date_Get() {
        const CurrentDate = new Date();
        var Date_Month_Index = CurrentDate.getMonth();
        var Date_Month_Array = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var Date_Month = Date_Month_Array[Date_Month_Index];
        var Date_Day = CurrentDate.getDate();
        var Date_Year = CurrentDate.getFullYear();
        return `${Date_Day} ${Date_Month} ${Date_Year}`;
    }

    Date_Format(DateValue) {
        const CurrentDate = DateValue;
        var Date_Month_Index = CurrentDate.getMonth();
        var Date_Month_Array = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var Date_Month = Date_Month_Array[Date_Month_Index];
        var Date_Day = CurrentDate.getDate();
        var Date_Year = CurrentDate.getFullYear();
        return `${Date_Day} ${Date_Month} ${Date_Year}`;
    }
    Toasts_TotalCount = 1;
    Toasts_CreateToast(Toast_IconLink, Toast_Title_Text, Toast_Content_Text) {
        var Toast_Div = document.createElement('div');
        Toast_Div.className = "Toast";
        Toast_Div.setAttribute("id", "Toast_" + this.Toasts_TotalCount);
        Toast_Div.setAttribute("onclick", "Toasts_CloseToast(this.id)");
        Toast_Div.style.animationName = "Toast_Open";
        Toast_Div.style.animationDuration = "0.3s";
        Toast_Div.style.animationFillMode = "forwards";
        setTimeout(function () {
            Toast_Div.style.animationName = "Toast_Close";
            Toast_Div.style.animationDuration = "0.3s";
            Toast_Div.style.animationFillMode = "forwards";
            setTimeout(function () {
                Toast_Div.style.display = "none";
            }, 300);
        }, 3000);
        document.getElementById("Toasts").appendChild(Toast_Div);


        var Toast_Icon = document.createElement('img');
        Toast_Icon.className = "Toast_Icon";
        Toast_Icon.src = Toast_IconLink;

        var Toast_Title = document.createElement('h2');
        Toast_Title.className = "Toast_Title";
        Toast_Title.innerHTML = Toast_Title_Text;

        var Toast_Content = document.createElement('p');
        Toast_Content.className = "Toast_Content";
        Toast_Content.innerHTML = Toast_Content_Text;
        document.getElementById("Toast_" + this.Toasts_TotalCount).appendChild(Toast_Icon);
        document.getElementById("Toast_" + this.Toasts_TotalCount).appendChild(Toast_Title);
        document.getElementById("Toast_" + this.Toasts_TotalCount).appendChild(Toast_Content);
        this.Toasts_TotalCount++;
    }

    Time_Combine(ID_Date, ID_Time) {
        try {
            var Input_Date = this.Element_Value_Get(ID_Date);
            var Input_Time = this.Element_Value_Get(ID_Time);
            if (!Input_Date || !Input_Time) {
                console.error("Error.");
                return null;
            }
            var String = `${Input_Date}T${Input_Time}`;
            var Date_Object = new Date(String);
            return Date_Object;
        } catch (Error) {
            console.error(Error);
        }


    }

    Emit(Name, Data) {
        this.emit(Name, Data);
    }
}

export const Manager_UI = new ERUMAUI_Manager();